import React, {FC} from 'react';
import LocationPriceInfoBoxBase from './LocationPriceInfoBoxBase';
import {IInfoBox} from "./interfaces";

const RequestSpaceInfoBox: FC<IInfoBox> = (props) => {
  const {formattedPrice, onClick, listHover} = props;
  return <LocationPriceInfoBoxBase formattedPrice={formattedPrice}
                                   onClick={onClick}
                                   severity={'warning'}
                                   listHover={listHover}
  />
}

export default RequestSpaceInfoBox;
